
window.LoyaltyPointsAB = {
  variant: null,
  initialized: false,

  // Convert calls this to set the variant
  setVariant: function(v) {
    this.variant = v;
    
    if (v === 'show') {
      this._enableLoyaltyPoints();
    }
    // if variant is anything else or not set, loyalty points stay hidden
  },

  // Internal - actually show the loyalty points
  _enableLoyaltyPoints: function() {
    if (this.initialized) return; // don't double-init
    
    const elements = document.querySelectorAll('.product__lower-stock-item--loyalty-points');
    elements.forEach(el => {
      el.style.display = 'flex';
      // Also show the parent container
      if (el.parentElement) {
        el.parentElement.style.display = 'block';
      }
      el.classList.add('ab-enabled');
    });

    this._refreshLionUI();
    this.initialized = true;
  },

  _refreshLionUI: function() {
    if (window.loyaltylion?.ui?.refresh) {
      window.loyaltylion.ui.refresh();
    } else {
      var attempts = 0;
      var interval = setInterval(function() {
        attempts++;
        if (window.loyaltylion?.ui?.refresh) {
          window.loyaltylion.ui.refresh();
          clearInterval(interval);
        } else if (attempts >= 30) {
          clearInterval(interval);
        }
      }, 100);
    }
  },

  isShowVariant: function() {
    return this.variant === 'show';
  }
};

// Re-show the loyalty tile after global.js replaces .js-stock-info on variant changes.
(function() {
  function restoreAfterVariantChange() {
    if (!window.LoyaltyPointsAB?.isShowVariant()) return;

    const elements = document.querySelectorAll('.product__lower-stock-item--loyalty-points');
    elements.forEach(function(el) {
      el.style.display = 'flex';
      el.classList.add('ab-enabled');
      if (el.parentElement) {
        el.parentElement.style.display = 'block';
      }
    });

    // Cycling the attribute forces LL to recalculate — ui.refresh() 
    document.querySelectorAll('[data-lion-price-for-product-id]').forEach(function(span) {
      var id = span.getAttribute('data-lion-price-for-product-id');
      span.removeAttribute('data-lion-price-for-product-id');
      span.setAttribute('data-lion-price-for-product-id', id);
    });
    document.querySelectorAll('[data-lion-points-for-product-id]').forEach(function(span) {
      var id = span.getAttribute('data-lion-points-for-product-id');
      span.removeAttribute('data-lion-points-for-product-id');
      span.setAttribute('data-lion-points-for-product-id', id);
    });

    window.LoyaltyPointsAB._refreshLionUI();
  }

  function attachVariantListener() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, restoreAfterVariantChange);
    } else {
      setTimeout(attachVariantListener, 100);
    }
  }

  attachVariantListener();
})();
